import React, { useRef, useState, useEffect } from 'react';
import './style.scss';
import Tooltip from '../../ui-elements/Tooltip';

type MultiSegmentProgressBarProps = {
  data: [
    {
      value: number;
      color: string;
      tooltipText?: string;
    },
  ];
  total: number;
  width?: string;
};

const MultiSegmentProgressBar = ({ data, total, width }: MultiSegmentProgressBarProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // for handelling bar width change on screen size change
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // Cleanup: remove the event listener when the component is unmounted
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (ref.current) {
      setContainerWidth(ref.current.clientWidth);
    }
  }, [screenSize.width]);
  return (
    <div style={{ width: width ?? '100%' }} className="MultiProgressBar__Container" ref={ref}>
      {data.map(barData => (
        <Tooltip title={barData.tooltipText} isIcon={true}>
          <div
            className="MultiProgressBar__Bar"
            style={{
              background: barData.color,
              width: `${Math.round((barData.value / total) * containerWidth)}px`,
            }}
          />
        </Tooltip>
      ))}
    </div>
  );
};

export default MultiSegmentProgressBar;
